import React from 'react';
import Dayz from 'dayz';
import moment from 'moment';
import CreateEventDialog from './CreateEventDialog';
import DeleteEventDialog from './DeleteEventDialog';
import BusyOverlay from './BusyOverlay';
import 'dayz/dist/dayz.css';
import './style/Calendar.css';
import API from '../api/api';

class Calendar extends React.Component {
    state = {
        events: {},
        selectedDate: null,
        calendarDate: moment(),
        busy: false
    }
    componentDidMount() {
        this.refresh();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.calendarDate !== prevState.calendarDate) {
            this.setState({selectedDate: null, events: {}});
            this.refresh();
        }
    }
    render() {
        let dialog = null;
        if (this.state.selectedDate) {
            const existingEvent = this.state.events[this.state.selectedDate.format('YYYYMMDD')];
            if (existingEvent) {
                dialog = (
                    <DeleteEventDialog date={this.state.selectedDate} event={existingEvent}
                        key="EventDialog" onClose={this.closeDialog} />
                );
            } else {
                dialog = (
                    <CreateEventDialog date={this.state.selectedDate} key="EventDialog"
                        onClose={this.closeDialog} />
                );
            }
        }

        const events = new Dayz.EventsCollection(Object.values(this.state.events).map(entry => ({
            range: moment.range(entry.date.clone().hour(0), entry.date.clone().hour(23)),
            content: entry.membernr + " " + entry.firstname + ' ' + entry.lastname
        })));
        let busyOverlay = null;
        if (this.state.busy) {
            busyOverlay = (<BusyOverlay key="busyOverlay" type="fullscreen" />);
        }

        return [
            (
                <div className="calendar-container" key="Calendar">
                    <div className="calendar-header">
                        {this.renderMonthPicker()}
                        {process.env.NODE_ENV !== 'production' ? (<span className="calendar-header-dev">DEVELOPMENT</span>) : null}
                    </div>
                    <Dayz date={this.state.calendarDate} dayEventHandlers={{onClick: this.createEditEvent}} display='month'
                        events={events}
                        highlightDays={this.dayHighlighter}
                        onEventClick={(ev, event) => this.createEditEvent(ev, event.start)} />
                </div>
            ),
            dialog,
            busyOverlay
        ];
    }
    renderMonthPicker = () => {
        const months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
        return (
            <span className="calendar-picker">
                <select onChange={ev => this.setMonth(ev.target.value)} value={this.state.calendarDate.month()}>
                    {months.map((entry, idx) => (
                        <option key={idx} value={idx}>{entry}</option>
                    ))}
                </select>
                <span className="calendar-year">
                    {moment().year()}
                </span>
            </span>
        );
    }
    refresh = () => {
        const start = moment(this.state.calendarDate);
        start.subtract(1, 'months').startOf('month');
        const end = moment(this.state.calendarDate);
        end.add(1, 'months').endOf('month');
        this.setState({busy: true});
        API.getEvents(start, end, (events) => {
            this.setState({events: events, busy: false});
        });
    }
    setMonth = (month) => {
        this.setState({calendarDate: this.state.calendarDate.clone().month(month)});
    }
    createEditEvent = (ev, day) => {
        this.setState({selectedDate: day});
    }
    closeDialog = (refresh = false) => {
        this.setState({selectedDate: null});
        if (refresh) {
            this.refresh();
        }
    }
    dayHighlighter = (day) => {
        return this.state.events[day.format('YYYYMMDD')] ? 'highlight' : '';
    }
}

export default Calendar;
